import { Outlet } from 'react-router-dom';
import { AgreementListHeader } from './components/agreement-list-header.component';
import { PageListLayout } from '../../../components/layout/page-list-layout';
import { useTranslation } from 'react-i18next';

export function AgreementListLayout() {
  const { t } = useTranslation('agreements');

  return (
    <PageListLayout breadcrumb={t('overview')}>
      <AgreementListHeader />
      <Outlet />
    </PageListLayout>
  );
}
